import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-credit',
  imports: [CommonModule],
  template: `
    <svg
      width="24"
      height="24"
      viewBox="0 0 13 13"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_368_2850)">
        <path
          d="M11.5489 1.57959H1.3366C0.998631 1.5815 0.675049 1.71661 0.436065 1.9556C0.197081 2.19458 0.0619735 2.51816 0.0600586 2.85613V10.1507C0.0619735 10.4886 0.197081 10.8122 0.436065 11.0512C0.675049 11.2902 0.998631 11.4253 1.3366 11.4272H11.5489C11.8869 11.4253 12.2105 11.2902 12.4495 11.0512C12.6884 10.8122 12.8236 10.4886 12.8255 10.1507V2.85613C12.8236 2.51816 12.6884 2.19458 12.4495 1.9556C12.2105 1.71661 11.8869 1.5815 11.5489 1.57959ZM1.3366 2.67377H11.5489C11.5973 2.67377 11.6437 2.69298 11.6779 2.72718C11.7121 2.76138 11.7313 2.80777 11.7313 2.85613V4.4974H1.15424V2.85613C1.15424 2.80777 1.17345 2.76138 1.20765 2.72718C1.24185 2.69298 1.28823 2.67377 1.3366 2.67377ZM11.5489 10.333H1.3366C1.28823 10.333 1.24185 10.3138 1.20765 10.2796C1.17345 10.2454 1.15424 10.199 1.15424 10.1507V5.59158H11.7313V10.1507C11.7313 10.199 11.7121 10.2454 11.6779 10.2796C11.6437 10.3138 11.5973 10.333 11.5489 10.333Z"
          [ngClass]="{
            'fill-black': color === 'black',
            'fill-white': color === 'white'
          }"
        />
        <path
          d="M4.25427 7.23291H2.79537C2.60191 7.23291 2.41637 7.30976 2.27957 7.44656C2.14277 7.58336 2.06592 7.7689 2.06592 7.96236C2.06592 8.15583 2.14277 8.34136 2.27957 8.47816C2.41637 8.61496 2.60191 8.69181 2.79537 8.69181H4.25427C4.44774 8.69181 4.63328 8.61496 4.77007 8.47816C4.90687 8.34136 4.98373 8.15583 4.98373 7.96236C4.98373 7.7689 4.90687 7.58336 4.77007 7.44656C4.63328 7.30976 4.44774 7.23291 4.25427 7.23291Z"
          [ngClass]="{
            'fill-black': color === 'black',
            'fill-white': color === 'white'
          }"
        />
      </g>
      <defs>
        <clipPath id="clip0_368_2850">
          <rect
            width="12.7654"
            height="12.7654"
            [ngClass]="{
              'fill-black': color === 'black',
              'fill-white': color === 'white'
            }"
            transform="translate(0.0600586 0.120605)"
          />
        </clipPath>
      </defs>
    </svg>
  `
})
export class CreditComponent {
  @Input() color = 'black';
}
